import { joinEventGuardLoader } from "routes/loaders/joinEventGuardLoader";
import { eventDetailsGuardLoader } from "routes/loaders/eventDetailsGuardLoader";

const usersRoutes = [
  {
    path: "join/:presentationId",
    loader: joinEventGuardLoader,
    lazy: async () => {
      const [joinMod, errorMod] = await Promise.all([
        import("views/User/JoinPresentation"),
        import("views/ErrorPage/EventNotFound"),
      ]);
      const JoinPresentation = joinMod.default;
      const EventNotFound = errorMod.default;
      return { Component: JoinPresentation, ErrorBoundary: EventNotFound };
    },
  },
  {
    path: "waiting-area/",
    lazy: async () => {
      const mod = await import("views/User/WaitingArea");
      const WaitingArea = mod.default;
      return { Component: WaitingArea };
    },
  },
  {
    path: "viewer-mode/:friendlyId",
    lazy: async () => {
      const mod = await import("views/User/ViewerMode");
      const ViewerMode = mod.default;
      return { Component: ViewerMode };
    },
  },
  {
    path: "viewer-mode-new/:friendlyId",
    lazy: async () => {
      const mod =
        await import("views/User/ViewerMode/user-presentation-screen");
      // @ts-ignore
      const UserPresentationScreen = mod.UserPresentationScreen;
      return { Component: UserPresentationScreen };
    },
  },
  {
    path: "viewer-mode-preview/:friendlyId",
    lazy: async () => {
      const mod =
        await import("views/User/ViewerMode/user-presentation-screen");
      const UserPresentationScreen = mod.UserPresentationScreen;
      return { Component: UserPresentationScreen };
    },
  },
  {
    path: "presentation-ended",
    lazy: async () => {
      const mod =
        await import("views/User/PresentationStatus/PresentationEnded");
      const PresentationEnded = mod.default;
      return { Component: PresentationEnded };
    },
  },
  {
    path: "removed",
    lazy: async () => {
      const mod = await import("views/User/RemovedUser");
      const RemovedUser = mod.default;
      return { Component: RemovedUser };
    },
  },

  // Accept collaboration invite
  {
    path: "acceptinvite/:friendlyId",
    lazy: async () => {
      const mod = await import("views/User/AcceptTeamInvite");
      const AcceptTeamInvite = mod.default;
      return { Component: AcceptTeamInvite };
    },
  },

  // shared briefcase
  {
    path: "shared-briefcase/:presentationId",
    lazy: async () => {
      const mod = await import("views/User/SharedBriefcase");
      const SharedBriefcase = mod.default;
      return { Component: SharedBriefcase };
    },
  },

  // access shared presentation
  {
    path: "access-shared-presentation/:presentationId",
    lazy: async () => {
      const mod = await import("views/User/JoinSharedPresentation");
      const JoinSharedPresentation = mod.default;
      return { Component: JoinSharedPresentation };
    },
  },

  // bookings (absolute path)
  {
    path: "/book",
    lazy: async () => {
      const mod = await import("views/User/Bookings");
      const Bookings = mod.default;
      return { Component: Bookings };
    },
  },
  {
    path: "book/:bookingId",
    lazy: async () => {
      const mod = await import("views/User/Bookings/Book");
      const Book = mod.default;
      return { Component: Book };
    },
  },

  // thank you (absolute path)
  {
    path: "/thank-you",
    lazy: async () => {
      const mod = await import("views/User/Post-Event/post-event");
      const EventThankYouPage = mod.EventThankYouPage;
      return { Component: EventThankYouPage };
    },
  },

  // event registration / check-in / details
  {
    path: "/event-registration/:eventId",
    lazy: async () => {
      const mod = await import("views/Admin/Events/Event-Registration");
      const EventRegistration = mod.EventRegistration;
      return { Component: EventRegistration };
    },
  },
  {
    path: "/check-in/:eventId",
    lazy: async () => {
      const mod = await import("views/Admin/Events/Event-Check-in");
      const EventCheckIn = mod.EventCheckIn;
      return { Component: EventCheckIn };
    },
  },
  {
    path: "/event-details/:eventId",
    loader: eventDetailsGuardLoader,
    lazy: async () => {
      const [eventMod, errorMod] = await Promise.all([
        import("components/User/Event/event-user-page"),
        import("views/ErrorPage/EventNotFound"),
      ]);
      const EventUserPage = eventMod.EventUserPage;
      const EventNotFound = errorMod.default;
      return { Component: EventUserPage, ErrorBoundary: EventNotFound };
    },
  },

  {
    path: "/event-ticket-registration",
    lazy: async () => {
      const mod = await import("components/User/Event/event-user-registration");
      const EventUserRegistration = mod.EventUserRegistration;
      return { Component: EventUserRegistration };
    },
  },

  {
    path: "/event-organiser/:organizerId",
    lazy: async () => {
      const mod =
        await import("components/User/Event/organiser-page/event-organiser-page");
      const EventOrganiserPage = mod.EventOrganiserPage;
      return { Component: EventOrganiserPage };
    },
  },

  // speaker landing
  {
    path: "/speaker",
    lazy: async () => {
      const mod = await import("views/User/SpeakerLandingPage");
      const SpeakerLandingPage = mod.default;
      return { Component: SpeakerLandingPage };
    },
  },

  // {
  //   path: "/emailstudio",
  //   lazy: async () => {
  //     const mod = await import("views/Admin/Bookings/EmailStudio");
  //     const EmailStudio = mod.default;
  //     return { Component: EmailStudio };
  //   },
  // },
];

export default usersRoutes;
